export default __webpack_public_path__ + "static/media/1895.3b2b4fde.png";